import isEmail from 'validator/lib/isEmail';

import { Trans } from '@lyearn/i18n';

import fieldValidate from '../../helper/fieldValidate';
import {
  FieldType,
  FieldValidationFunction,
  FieldValidationTypes,
  FormTextField,
} from '../../types';
import Input from '../text/Input';
import { FieldInputType } from '../types';

const fieldValidation: FieldValidationFunction<string> = {
  [FieldValidationTypes.Required]: ({ value, validation }) => {
    if (!value) {
      return validation?.message || <Trans i18nKey="Form:FieldRequiredMessage" />;
    } else if (!isEmail(value)) {
      return <Trans i18nKey="Form:ValidEmailMessage" />;
    }
  },
  [FieldValidationTypes.Custom]: () => undefined,
};

const EmailInputField: FieldInputType<FormTextField, string> = {
  Input,
  type: FieldType.Email,
  validate: (field, value, values) => {
    return fieldValidate({ field, value, values, fieldValidation });
  },
};

export default EmailInputField;
